import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { FaStar } from "react-icons/fa";
import { Autoplay, Pagination } from "swiper/modules";
import "./TestimonialWithParallaxSection.css";
import { Skeleton } from "antd";
export default function TestimonialWithParallaxSection({
  testimonialData,
  bannerData,
}) {
  const renderFullStars = (rating) => {
    const fullStars = [];
    for (let i = 0; i < rating; i++) {
      fullStars.push(<FaStar key={i} />);
    }
    return fullStars;
  };
  var image1 = bannerData.filter(
    (item) => item.location === "TestimonialBackground"
  );
  return (
    <div
      className="section-spacing-x section-spacing-x-mobile my-4 testimonial-parallax"
      style={{
        background: `url(${image1[0]?.image.split("$")[0]?.split("#")[0]})`,
      }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-7 ms-lg-auto position-relative">
            {/* <div className="icon">
              <RiDoubleQuotesL />
            </div> */}
            <Swiper
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              slidesPerView=" 1"
              autoplay="flase"
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper py-5 mb-lg-4">
              {testimonialData.length > 0 ? (
                testimonialData?.map((data, index) => {
                  return (
                    <SwiperSlide
                      key={`testimonial-${index}`}
                      className="bg-white">
                      <div className="review-card border h-100 m-3">
                        {/* <div className="img">
                            <img
                              alt=""
                              src={data.fld_image}
                              className="img-fluid"
                            />
                          </div> */}
                        <div className="content">
                          <p>{data.fld_feedback}</p>
                          <ul>
                            <li>{renderFullStars(data.fld_rating)}</li>
                          </ul>
                          <p className="mb-0">{data.fld_name}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })
              ) : (
                <>
                  <SwiperSlide>
                    <Skeleton.Image className="h-100 w-100" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image className="h-100 w-100" />
                  </SwiperSlide>
                </>
              )}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
